import { Link } from "react-router-dom";

/**
 * Shared candidate-portal chrome. Renders the same header + minimal
 * footer used across public pages (Landing, JD, Apply, Attend, Thank You).
 */
export default function SiteChrome({ children, eyebrow = "Careers" }) {
    return (
        <div
            data-testid="site-chrome"
            className="min-h-screen bg-[#F7F5F0] text-[#0F1F38] font-sans flex flex-col"
        >
            <header
                data-testid="candidate-header"
                className="border-b border-[#0F1F38]/10 bg-[#F7F5F0]/95 backdrop-blur-xl sticky top-0 z-30"
            >
                <div className="max-w-6xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
                    <Link
                        to="/"
                        data-testid="brand-logo"
                        className="inline-flex items-center"
                    >
                        <img
                            src="/blubridge-logo.png"
                            alt="BluBridge"
                            className="h-6 md:h-7 w-auto"
                        />
                    </Link>
                    <span className="text-[10px] tracking-label uppercase text-[#0F1F38]/60">
                        {eyebrow}
                    </span>
                </div>
            </header>

            <main className="flex-1">{children}</main>

            <footer
                data-testid="site-footer"
                className="border-t border-[#0F1F38]/10 bg-[#F7F5F0]/60"
            >
                <div className="max-w-6xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#0F1F38]/60">
                    <div>© {new Date().getFullYear()} BluBridge Technologies</div>
                    <div className="tracking-label uppercase">
                        Careers · Attendance · Support
                    </div>
                </div>
            </footer>
        </div>
    );
}
